import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import countryJsonGB from './../../../assets/json/country-code-gb.json';
import countryJsonNL from './../../../assets/json/country-code-nl.json';
import { CountryModel } from '../questions';
import { DashboardService } from '../../dashboard';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
})
export class CountrySelectComponent implements OnInit, AfterViewInit {
  @ViewChild('countries') countriesSelector!: NgModel;

  @Input()
  countryCode = '';

  @Input()
  language!: string;

  @Input()
  disabled = false;

  @Input()
  fieldIndex?: number;

  @Input()
  putCoreCountriesOnTop = true;

  @Input()
  touchOnInit = false;

  @Output()
  answerChangedEmitter = new EventEmitter<string>();

  countryList: CountryModel[] = [];

  constructor(public service: DashboardService) {}

  ngOnInit(): void {
    if (this.language === 'nl_NL') {
      this.countryList = countryJsonNL as CountryModel[];
    } else {
      this.countryList = countryJsonGB as CountryModel[];
    }
  }

  ngAfterViewInit(): void {
    if (this.touchOnInit) {
      this.countriesSelector.control.markAsTouched();
    }
  }

  onSelectionChange(): void {
    this.answerChangedEmitter.emit(this.countryCode);
  }
}
